export default __webpack_public_path__ + "static/media/discover.964c4bed.svg";